import axios from 'axios';

import { processResponse } from './helpers';
import createResponseErrorInterceptor from './interceptors/responseInterceptor';

export interface IRestResponse {
	code: string;
	data: any;
}

const instance = axios.create({
	baseURL: process.env.ENV_CLIENT_API_URL,
});

instance.interceptors.response.use(
	processResponse,
	createResponseErrorInterceptor(instance),
);

export default instance;
